// extracted by mini-css-extract-plugin
export default {"suggestionChips":"SuggestionChips_suggestionChips__74tG7","scroller":"SuggestionChips_scroller__+gmDE","chip":"SuggestionChips_chip__WR2gb"};